import { Tooltip } from '@mui/material'
import React, { useState, useEffect, forwardRef, cloneElement } from 'react'
import {
  EditButton,
  ShowButton,
  useRecordContext,
  useResourceContext,
  useResourceDefinitions,
  useStore,
  useTranslate,
} from 'react-admin'
import { DisableUserButton } from 'src/components/pages/authentication/user/logic/disableButon'
import { getResourceName } from 'src/helper/getResourceName'
import { DeleteButtonWithConfirmation } from './DeleteButtonWithConfirmation'
import { VersionButton } from 'src/components/uiElements/buttons/VersionButton'
import { CloneButton } from 'src/components/uiElements/buttons/CloneButton'

const TooltipWrapper = forwardRef(({ children, ...props }, ref) => (
  <div ref={ref}>{cloneElement(children, props)}</div>
))

export const ListViewActionsButtons = ({ DeleteButtonComponent, ...props }) => {
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const translate = useTranslate()
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()
  const record = useRecordContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  return (
    <div style={{ display: 'flex' }}>
      {props?.clone && (
        <Tooltip placement='top' title='Clonar'>
          <TooltipWrapper>
            <div>
              <CloneButton />
            </div>
          </TooltipWrapper>
        </Tooltip>
      )}
      {permissions?.options?.revision && !props.disableRevision && (
        <Tooltip placement='top' title='Versiones'>
          <TooltipWrapper>
            <div>
              <VersionButton />
            </div>
          </TooltipWrapper>
        </Tooltip>
      )}
      {permissions?.hasShow && (
        <Tooltip placement='top' title={translate('ra.action.see_details')} aria-label='show'>
          <TooltipWrapper>
            <ShowButton label={null} />
          </TooltipWrapper>
        </Tooltip>
      )}
      {permissions?.hasEdit && !props.disableEdit && (
        <Tooltip placement='top' title={translate('ra.action.edit')} aria-label='edit'>
          <TooltipWrapper>
            <EditButton label={null} />
          </TooltipWrapper>
        </Tooltip>
      )}

      {permissions?.options?.delete && !props.disableDelete && (
        <Tooltip placement='top' title={translate('ra.action.delete')} aria-label='delete'>
          <TooltipWrapper>
            {props.actionDisable ? (
              <DisableUserButton name={getResourceName(record, props.fieldsName)} />
            ) : DeleteButtonComponent ? (
              <DeleteButtonComponent
                record={record}
                resource={resourceName}
                name={getResourceName(record, props.fieldsName)}
                genderElement={props.genderElement}
              />
            ) : (
              <DeleteButtonWithConfirmation
                record={record}
                resource={resourceName}
                name={getResourceName(record, props.fieldsName)}
                genderElement={props.genderElement}
              />
            )}
          </TooltipWrapper>
        </Tooltip>
      )}
    </div>
  )
}
